import { render, staticRenderFns } from "./DataViewSidebarCorporates.vue?vue&type=template&id=262d566e&scoped=true&"
import script from "./DataViewSidebarCorporates.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarCorporates.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarCorporates.vue?vue&type=style&index=0&id=262d566e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d566e",
  null
  
)

export default component.exports